import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import axios from 'axios';
import { toast } from 'react-toastify';

export const Admin = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [users, setUsers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    if (!token || user.role !== 'admin') {
      navigate('/login');
      return;
    }

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      const [statsRes, usersRes, driversRes, ordersRes] = await Promise.all([
        axios.get('/api/admin/dashboard', { headers }),
        axios.get('/api/admin/users', { headers }),
        axios.get('/api/admin/drivers', { headers }),
        axios.get('/api/admin/orders', { headers })
      ]);

      setStats(statsRes.data.data);
      setUsers(usersRes.data.data);
      setDrivers(driversRes.data.data);
      setOrders(ordersRes.data.data);
    } catch (error) {
      toast.error('Gagal memuat data admin');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Layout title="Admin"><div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div></Layout>;

  return (
    <Layout title="🛡️ Admin Panel" subtitle="Dashboard OJESI">
      {/* Stats Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', padding: '0 16px' }}>
        <div className="tg-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: 'var(--tg-blue)' }}>{stats.total_users || 0}</div>
          <div style={{ fontSize: '12px', color: 'var(--tg-gray)' }}>Total Users</div>
        </div>
        <div className="tg-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: 'var(--tg-green)' }}>{stats.total_drivers || 0}</div>
          <div style={{ fontSize: '12px', color: 'var(--tg-gray)' }}>Total Drivers</div>
        </div>
        <div className="tg-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: 'var(--tg-blue)' }}>{stats.total_orders || 0}</div>
          <div style={{ fontSize: '12px', color: 'var(--tg-gray)' }}>Total Orders</div>
        </div>
        <div className="tg-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: 'var(--tg-red)' }}>{stats.pending_drivers || 0}</div>
          <div style={{ fontSize: '12px', color: 'var(--tg-gray)' }}>Pending Drivers</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '8px', padding: '8px 16px' }}>
        {['dashboard', 'users', 'drivers', 'orders'].map(tab => (
          <button
            key={tab}
            className={`tg-btn ${activeTab === tab ? 'tg-btn-primary' : 'tg-btn-outline'}`}
            style={{ width: 'auto', padding: '8px 16px', fontSize: '12px' }}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{ padding: '0 16px' }}>
        {activeTab === 'users' && (
          <div className="tg-card">
            <div className="tg-card-title">📋 Users</div>
            <div style={{ fontSize: '12px', maxHeight: '400px', overflow: 'auto' }}>
              {users.map(user => (
                <div key={user.id} style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ fontWeight: '600' }}>{user.full_name}</div>
                  <div style={{ color: 'var(--tg-gray)' }}>{user.phone} • {user.gender} • {user.role}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'drivers' && (
          <div className="tg-card">
            <div className="tg-card-title">🚗 Drivers</div>
            <div style={{ fontSize: '12px', maxHeight: '400px', overflow: 'auto' }}>
              {drivers.map(driver => (
                <div key={driver.id} style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ fontWeight: '600' }}>{driver.full_name}</div>
                  <div style={{ color: 'var(--tg-gray)' }}>{driver.phone} • Status: {driver.status}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'orders' && (
          <div className="tg-card">
            <div className="tg-card-title">📦 Orders</div>
            <div style={{ fontSize: '12px', maxHeight: '400px', overflow: 'auto' }}>
              {orders.map(order => (
                <div key={order.id} style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ fontWeight: '600' }}>#{order.order_code}</div>
                  <div style={{ color: 'var(--tg-gray)' }}>{order.customer_name} • {order.service_type} • {order.order_status}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
